<template>
    <PDataTable ref="table" v-bind="$attrs">
        <template v-for="(_, name) in $slots" #[name]="scope">
            <slot :name="name" v-bind="scope || {}" />
        </template>
        <template v-if="!$slots.empty" #empty>
            <div class="flex justify-content-center align-items-center p-2">
                <span>No items added yet.</span>
            </div>
        </template>
    </PDataTable>
</template>

<script>
import PDataTable from "primevue/datatable";

export default {
    name: "DataTable",
    components: { PDataTable },
    inheritAttrs: false,
    computed: {
        rows() {
            return this.$refs.table?.rows;
        },
    },
};
</script>